import React from 'react';

import {
  RowsSkeletonContainer,
  SkeletonBlock,
  SkeletonControlsRow,
  SkeletonDateField,
  SkeletonLocationField,
  SkeletonRowCard,
  SkeletonRowGrid,
  FlexContainer,
} from './styles';

/**
 * Enough cards to fill a phone and to show a desktop that its grid has more than one line — the
 * cards wrap two or three to a line there, so a handful that fits in one row would read as a short
 * list rather than a loading one.
 */
const CARD_COUNT = 6;

const CARDS = Array.from({ length: CARD_COUNT }, (_, index) => index);

/**
 * The loading state of the redesigned resources page: the view toggle, the location and date fields,
 * and the row cards — laid out exactly as they load, side by side on a desktop and stacked on a
 * phone, so nothing moves when the data arrives.
 *
 * Shown for both views on purpose — the map's own loading state is this same skeleton, so switching
 * to the floorplan does not swap one loading shape for another mid-wait.
 */
export const ResourceRowsSkeleton = (): JSX.Element => (
  <RowsSkeletonContainer data-testid="resource-rows-skeleton">
    {/* The List/Floorplan pill. */}
    <SkeletonBlock width="150px" height="36px" radius="9999px" />
    <SkeletonControlsRow>
      <SkeletonLocationField>
        <SkeletonBlock height="36px" radius="11px" />
      </SkeletonLocationField>
      <SkeletonDateField>
        <SkeletonBlock height="36px" radius="11px" grow />
        <SkeletonBlock width="36px" height="36px" radius="11px" />
      </SkeletonDateField>
    </SkeletonControlsRow>
    <SkeletonRowGrid>
      {CARDS.map(card => (
        <SkeletonRowCard key={card} data-testid="resource-rows-skeleton-card">
          <SkeletonBlock width="64px" height="64px" radius="11px" />
          <FlexContainer gap={8} isColumnDirection isWidth>
            <SkeletonBlock width="60%" height="16px" />
            <SkeletonBlock width="40%" height="13px" />
            <SkeletonBlock width="25%" height="13px" />
          </FlexContainer>
        </SkeletonRowCard>
      ))}
    </SkeletonRowGrid>
  </RowsSkeletonContainer>
);
